module.exports = __webpack_public_path__ + "img/plate_2.82264fce.png";